/**
 * 說明 : 電梯資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

export const fetchDispatchList = createAsyncThunk(
  'dispatch/fetchDispatchList',
  async (
    {
      caseNumber,
      machineSerialNumber,
      employeeCode,
      employeeName,
      startTime,
      endTime,
      customerCode,
      available,
      casePriority,
      requireSameDepartment = false,
      salesOrderNo,
      invoiceNo,
      quotationNo,
    },
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      console.log('into fetchDispatchCalendarList');
      console.log('caseNumber:', caseNumber);
      console.log('machineSerialNumber:', machineSerialNumber);
      console.log('employeeCode:', employeeCode);
      console.log('employeeName:', employeeName);
      console.log('startTime:', startTime);
      console.log('endTime:', endTime);
      console.log('customerCode:', customerCode);
      console.log('available:', available);
      console.log('casePriority:', casePriority);
      console.log('requireSameDepartment', requireSameDepartment);
      console.log('salesOrderNo', salesOrderNo);
      console.log('invoiceNo', invoiceNo);
      console.log('quotationNo', quotationNo);

      // ✅ 先組成原始參數物件
      const rawParams = {
        caseNumber,
        machineSerialNumber,
        employeeCode,
        employeeName,
        startTime,
        endTime,
        customerCode,
        available,
        casePriority,
        requireSameDepartment,
        salesOrderNo,
        invoiceNo,
        quotationNo,
      };

      // ✅ 過濾掉 null、''、undefined
      const filteredParams = Object.fromEntries(
        Object.entries(rawParams).filter(
          ([_, v]) => v !== null && v !== '' && v !== undefined,
        ),
      );

      // ✅ Debug log
      console.log('[fetchDispatchList] filtered params =', filteredParams);
      console.log(
        '[fetchDispatchList] query string =',
        new URLSearchParams(filteredParams).toString(),
      );

      const data = await BaseAPI.getWithAuth(
        '/dispatch',
        filteredParams,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch dispatch list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchDispatchCalendarList = createAsyncThunk(
  'dispatch/fetchDispatchCalendarList',
  async (
    {
      caseNumber,
      machineSerialNumber,
      employeeCode,
      employeeName,
      startTime,
      endTime,
      customerCode,
      available,
      requireSameDepartment = false,
    },
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      console.log('into fetchDispatchCalendarList');
      console.log('caseNumber:', caseNumber);
      console.log('machineSerialNumber:', machineSerialNumber);
      console.log('employeeCode:', employeeCode);
      console.log('employeeName:', employeeName);
      console.log('startTime:', startTime);
      console.log('endTime:', endTime);
      console.log('customerCode:', customerCode);
      console.log('available:', available);

      // ✅ 先組成原始參數物件
      const rawParams = {
        caseNumber,
        machineSerialNumber,
        employeeCode,
        employeeName,
        startTime,
        endTime,
        customerCode,
        available,
        requireSameDepartment,
      };

      // ✅ 過濾掉 null、''、undefined
      const filteredParams = Object.fromEntries(
        Object.entries(rawParams).filter(
          ([_, v]) => v !== null && v !== '' && v !== undefined,
        ),
      );

      // ✅ Debug log
      console.log('[fetchDispatchList] filtered params =', filteredParams);
      console.log(
        '[fetchDispatchList] query string =',
        new URLSearchParams(filteredParams).toString(),
      );

      const data = await BaseAPI.getWithAuth(
        '/dispatch',
        filteredParams,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch dispatch list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const editDispatch = createAsyncThunk(
  'dispatch/editDispatch',
  async (req, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/dispatch', req, token);
      return data;
    } catch (err) {
      console.error('fetch dispatch list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
